const Menu =  [
    { header: 'Sys Admin' },
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'dashboard', 
        meta    : {breadcrumb:false}
    },
    {
        path    : '/signup',
        title   : 'Signup',    
        name    : 'signup',  
        icon    : 'account_circle', 
        meta    : {breadcrumb:true}
    },
    {
        path    : '/calon',
        title   : 'Administrasi',    
        name    : 'calon',  
        icon    : 'group', 
        meta    : {breadcrumb:true}
    },    
    {
        path    : '/ruangan',
        title   : 'Ruangan',    
        name    : 'ruangan',  
        icon    : 'view_module', 
        meta    : {breadcrumb:true}
    },
    {
        path    : '/calon/rekap',
        title   : 'Rekap Data',    
        name    : 'calon/rekap',  
        icon    : 'list', 
        meta    : {breadcrumb:true}
    },
    {
        path    : '/calon/quran',
        title   : 'Tes Quran',    
        name    : 'calon/quran',  
        icon    : 'local_library', 
        //meta    : {breadcrumb:false}
    },
    {
        path    : '/tes/kelengkapan',
        title   : 'Kelengkapan',    
        name    : 'tes/kelengkapan',  
        icon    : 'assignment_turned_in', 
        //meta    : {breadcrumb:false}
    },  
    {
      path    : '/tes/rapor',
      title   : 'Rapor',    
      name    : 'tes/rapor',  
      icon    : 'local_library', 
      //meta    : {breadcrumb:false}
    },  
    //NON MENU
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Explore', name: 'explore', meta:{breadcrumbs:false} },
        { title : 'Live', name: 'live', meta:{breadcrumbs:false, public:true} },
      ]
    },   
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
    {
      group: 'tes',
      visible: false,
      items: [            
          { title : 'Wawancara', name: 'survey' },
          { title : 'List Wawancara', name: 'survey/respon' },
          { title : 'Rekap Wawancara', name: 'survey/respon/rekap' },
          { title : 'Ujian To Excel', name: 'ujian_excel' },
          { title : 'Ujian View', name: 'ujian_view' },
          { title : 'Rapor To Excel', name: 'rapor_excel' },
          { title : 'Form Wawancara', name: 'survey/respon/form', meta:{breadcrumbs:false} },
      ]
    },
    {
        group: 'adm',
        visible : false,
        items: [
            { title : 'Quetionnaire', name: 'quetionnaire/form'},
            { title : 'Mata Pelajaran', name: 'matpel/form'},
            { title : 'Provinsi', name: 'provinsi/form'},
            { title : 'Kota/Kab', name: 'kota/form' },
            { title : 'Kecamatan', name: 'kecamatan/form' },            
            { title : 'Kelurahan', name: 'kelurahan/form' },            
        ]
    },        
    { group: 'calon',
      visible: false,
      items:[
        { title : 'calon Form', name: 'form' },
        { title : 'calon View', name: 'view' }, 
        { title : 'kartu Ujian', name: 'card' }, 
      ]
    },
    { group: 'signup',
      visible: false,
      items:[
        { title : 'Signup Form', name: 'form' },
        { title : 'Calon Form', name: 'calon/form' }, 
        { title : 'Calon Form', name: 'calon/view' }, 
        { title : 'Payment', name: 'calon/payment' },        
        { title : 'Payment Form', name: 'calon/payment/form' },        
        { title : 'Payment View', name: 'calon/payment/view' },        
      ]
    },
    { group: 'user',
      visible: false,
      items:[
        { title : 'Calon', name: 'form' },        
      ]
    },    
    {
        title   : 'Auth',
        group   : 'rbac',
        visible: false,                   
        items: [            
            {title: 'User', name:'user/form'},
            {title: 'Permissions', name: 'permissions/form'},
            {title: 'Permissions', name: 'permissions/view'},
            {title: 'Roles', name: 'roles/form'},
            {title: 'Roles', name: 'roles/view'},
            {title: 'Assignment', name: 'assignment/view'}            
        ]
    },
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
